import { Report } from '../../models/report.model';

export const getViabilityLabel = (
  viability: Report.Characteristics.Viability,
): string => {
  switch (viability) {
    case Report.Characteristics.Viability.NON_BUILDABLE:
      return 'Non viabilisable';
    case Report.Characteristics.Viability.BUILDABLE:
      return 'Viabilisable';
    case Report.Characteristics.Viability.DEVELOPED_WITH_UTILITIES:
      return 'Viabilisé';
    default:
      return '';
  }
};
